module.exports = __webpack_public_path__ + "static/media/fylogo_white.7381b3f3.svg";